import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const FinalCTASection = () => {
  return (
    <section
      className="section-dark"
      style={{
        padding: '160px 5%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Grid Pattern */}
      <div className="grid-pattern" />

      {/* Background Glow */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(240, 106, 21, 0.15), transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      {/* Floating Particles */}
      <div className="particles">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${8 + Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <div
        className="container"
        style={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
        }}
      >
        {/* Title */}
        <h2
          style={{
            fontSize: 'clamp(40px, 6vw, 64px)',
            fontWeight: 800,
            marginBottom: '40px',
            lineHeight: 1.1,
            letterSpacing: '-2px',
          }}
        >
          Be the first to experience<br />
          <span style={{ color: '#f06a15' }}>your AI team.</span>
        </h2>

        {/* CTA Button */}
        <Link
          to="/coming-soon"
          className="btn-primary"
          style={{
            fontSize: '18px',
            padding: '20px 40px',
            display: 'inline-flex',
          }}
        >
          <span>Pre-register now</span>
          <ArrowRight size={20} />
        </Link>

        {/* Trust Points */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '40px',
            marginTop: '60px',
            flexWrap: 'wrap',
          }}
        >
          {['Early access to AI team', 'Be first to launch', 'Exclusive updates'].map((point, i) => (
            <span
              key={i}
              style={{
                fontSize: '14px',
                color: 'rgba(255, 255, 255, 0.5)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span style={{ color: '#f06a15' }}>✓</span>
              {point}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
